/**
 * Vytvoření unikátního id vnitřího elementu podle id obalujícího elementu (většinou nějakého editu)
 * @param id id obalujícího elementu
 * @returns id se suffixem _input
 */
export const inputIdFromId = (id: string) => `${id}_input`;
